<template>
  <i class="icon iconfont" :class="[ isExpand ? 'icon-minus' : 'icon-plus' ]" @click="updateIsExpandVal(!isExpand)" style="">&nbsp;{{ isExpand ? '收起' : '展开'}}</i>
</template>

<script>
export default {
  props: {
    isExpand: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    updateIsExpandVal(val) {
      this.$emit('update:isExpand', val);
    }
  }
};
</script>

<style lang="less" scoped>
  .icon{
    font-size:14px;
    cursor: pointer;
  }
</style>
